import { render, staticRenderFns } from "./Workbench.vue?vue&type=template&id=3e01bcb6&scoped=true"
import script from "./Workbench.vue?vue&type=script&lang=js"
export * from "./Workbench.vue?vue&type=script&lang=js"
import style0 from "./Workbench.vue?vue&type=style&index=0&id=3e01bcb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e01bcb6",
  null
  
)

export default component.exports